<template>
  <div>
    <!-- 头部 -->
    <navigation ref="navigation"></navigation>
    <div style="border-left:1px #e1e1e1 solid;border-right:1px #e1e1e1 solid;width:1000px;margin:0 auto;background: #fff">
      <div class="new_content" >
        <p style="height: 40px; padding-left: 30px; line-height: 40px; font-size: 14px; font-weight: bold;"><span style="color:#9f1b29;">提醒：</span>为了保证您第一时间获取培训有效证书，请如实填写以下注册信息，避免重复注册。</p>
        <el-form ref="form" :model="form" label-width="90px" style="padding: 30px;padding-left: 30px;color:#5f5f5f; font-size: 14px;" :rules="rules">
          <el-form-item label="证件类型" prop="cardType">
            <el-select v-model="form.cardType" placeholder="请选择证件类型">
              <el-option v-for="item in cardTypeOptions" :label="item.value" :value="item.key"
                         :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号" prop="cardNumber" style="width:46%">
            <el-input v-model="form.cardNumber" placeholder="请输入18位证件号"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username" style="width:46%">
            <el-input v-model="form.username" placeholder="用户名为6-20个字符，且字母在首位"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" style="width:46%">
            <el-input v-model="form.password" type="password" placeholder="6-22个字符，数字、字母、特殊符号，区分大小写"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="vpassword" style="width:46%">
            <el-input v-model="form.vpassword" type="password" placeholder="请再一次输入密码"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="realname" style="width:100%">
            <el-row>
              <el-col :span="10">
                <el-input v-model="form.realname" placeholder="请输入有效证件上的姓名，不要使用空格"></el-input>
              </el-col>
              <el-col :span="7">
                <el-button type="text" style="padding-left: 5px;"> ※颁发证书时将使用此名字，请如实填写！</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所在单位" prop="company" v-show="!form.isCustomComp">
            <!--非自填单位-->
            <el-row>
              <el-col :span="12">
                <el-select v-model="form.company"
                           style="width: 100%"
                           filterable
                           remote
                           placeholder="请输入关键词"
                           :remote-method="remoteSearchComp"
                           :loading="compLoading"
                           :no-data-text="compPrompt">
                  <el-option
                          v-for="item in compOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 10px">{{ formatRegion(item.province, item.city, item.county, item.rural)}}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-popover ref="popover1"
                            width="200"
                            trigger="hover"
                            placement="top"
                            v-model="customCompVisible">
                  <p>搜索单位时无需填写省市县名称，只需填写医院关键字即可，或者可以选择
                    <el-button size="mini" type="text" @click="showCustomComp()">切换自填单位</el-button>
                  </p>
                </el-popover>
                <el-button type="text" v-popover:popover1 v-show="searchCount>=5"> 找不到单位？</el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="自填单位" prop="company" v-show="form.isCustomComp">
            <!--自填单位-->
            <el-row>
              <el-col :span="4">
                <el-select v-model="form.customCompForm.province" placeholder="省" clearable @change="changeArea">
                  <el-option
                          v-for="item in provinceOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="form.customCompForm.city" placeholder="市" clearable @change="changeArea">
                  <el-option
                          v-for="item in cityOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="form.customCompForm.county" placeholder="县" clearable @change="changeArea">
                  <el-option
                          v-for="item in countyOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="form.customCompForm.rural" placeholder="乡" clearable>
                  <el-option
                          v-for="item in ruralOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-input v-model.trim="form.customCompForm.compName" placeholder="单位名称"></el-input>
              </el-col>
            </el-row>
            <el-button type="text" @click="swithSelectComp">选择已有单位</el-button>
          </el-form-item>
          <el-form-item label="所在科室" prop="department">
            <el-autocomplete
                    v-model="form.department"
                    :fetch-suggestions="searchDepartment"
                    placeholder="请输入内容"
                    @select="departmentSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="人员类别" prop="personType">
            <el-select v-model="form.personType" placeholder="请选择人员类别" @change="changePersonType">
              <el-option v-for="item in personTypeOptions" :label="item.value" :value="item.key"
                         :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="specialty">
            <el-select v-model="form.specialtyId1" placeholder="请选择专业1" @change="changeSpecialtyId1">
              <el-option v-for="item in specialtyId1Options" :label="item.value" :value="item.key"
                         :key="item.key"></el-option>
            </el-select>
            <el-select v-model="form.specialtyId2" placeholder="请选择专业2">
              <el-option v-for="item in specialtyId2Options" :label="item.value" :value="item.key"
                         :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职称" prop="title">
            <el-select v-model="form.title" placeholder="请选择职称">
              <el-option v-for="item in titleOptions" :label="item.value" :value="item.key"
                         :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图形验证码" prop="vcode">
            <el-row>
              <el-col :span="5">
                <el-input v-model="form.vcode"></el-input>
              </el-col>
              <el-col :span="17">
                <img :src="captchaUrl" @click="refreshCaptcha"
                     style="margin-left: 5px;width: 100px;border: 0"/>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-row>
              <el-col :span="5">
                <el-input v-model="form.phone"></el-input>
              </el-col>
              <el-col :span="17">
                <el-button style="margin-left: 5px;" @click="sendSmsMethod" :disabled="sendSmsButtonDisabled">
                  {{sendSmsButtonText}}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码" prop="vPhoneCode">
            <el-row>
              <el-col :span="5">
                <el-input v-model="form.vPhoneCode"></el-input>
              </el-col>
              <el-col :span="17">
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="text-align:center;margin: 0;">
            <el-button type="primary" @click="onSubmit" style="width:30%;" :disabled="!agreeContract" :loading="registerLoading">{{registerText}}</el-button>
            <br />
            <input type="checkbox" v-model="agreeContract" required/>
            <router-link to="/contract" target="_blank" style="font-size: 12px; line-height: 50px;">&nbsp;我已阅读并接受用户服务条款</router-link>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <footer1></footer1>
    <div id="J_GotoTop" class="elevator">
      <a href="javascript:void(0)" class="elevator-msg" onclick="doyoo.util.openChat('g=89472'); return false;">
        <i class="iconfont icon-kefu"></i>
        <span class="">在线客服</span>
      </a>
    </div>
  </div>
</template>

<script>
  import {
    getUserDictByColumType,
    listByCompName,
    getCustomAreaList,
    getdepartmentByOrgId,
    getSpecialty1Indexs,
    getSpecialty2Indexs,
    valilCaptcha,
    sendSms,
    validateMobileCode,
    verificationStudent,
    vftelStudent,
    checkUsername,
    studyRegister,
    login
  } from '../api/api';
  import util from '../common/js/util'
  import sha256 from 'crypto-js/sha256'
  import  navigation from '../components/Navigation';
  import  footer1 from '../components/Footer1'
  import md5 from 'crypto-js/md5'
  export default {
    components: {
      navigation,
      footer1
    },
    data () {
      var validateRealname=(rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入真实姓名'));
        }else{
          var pattern = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");
          if(!pattern.test(value)){
            callback(new Error('请输入真实姓名,不能带有空格和特殊字符'));
          }else{
            callback();
          }
        }
      };
      var validateCardNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入证件号'));
        } else if (this.form.cardType === '') {
          callback(new Error('请选择证件类型'));
        } else {
          if (this.form.cardType === '1') {
            if (!util.checkIdcard18(value)) {
              callback(new Error('证件号有误，请核实'));
            } else {
              verificationStudent({sertId: value}).then((response) => {
                let {data} = response
                if (!data) {
                  callback();
                } else {
                  callback(new Error('该证件号已被注册'));
                }
              })
            }
          } else {
            verificationStudent({sertId: value}).then((response) => {
              let {data} = response
              if (!data) {
                callback();
              } else {
                callback(new Error('证件号重复'));
              }
            })
          }
        }
      };
      var validateUsername = (rule, value, callback) => {
        var reg = /^[a-zA-Z][a-zA-Z0-9]*$/;
        if (value === '') {
          callback(new Error('请输入用户名'));
        } else if (reg.test(value) === false) {
          callback(new Error('用户名为6-20个字符，且字母在首位'));
        } else if (value.length < 6 || value.length > 20) {
          callback(new Error('用户名为6-20个字符，且字母在首位'));
        } else {
          checkUsername({username: value}).then((response) => {
            let {data} = response
            if (!data) {
              callback();
            } else {
              callback(new Error('该用户名已被其他用户使用，请更换其他用户名'));
            }
          })
        }
      };
      var validateVpassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateCompany = (rule, value, callback) => {
        if (this.form.isCustomComp) {
          if (!this.form.customCompForm.province || !this.form.customCompForm.city) {
            callback(new Error('自填单位至少填写到市一级'));
          } else if (!this.form.customCompForm.compName) {
            callback(new Error('请输入您的单位名称'));
          } else {
            callback();
          }
        } else {
          if (!value) {
            callback(new Error('请选择您所在的单位'));
          } else {
            callback();
          }
        }
      };
      var validateSpecialty = (rule, value, callback) => {
        if (!this.form.personType) {
          callback(new Error('请先选择人员类别'));
        } else if (!this.form.specialtyId1) {
          callback(new Error('请选择专业一'));
        } else if (!this.form.specialtyId2) {
          callback(new Error('请选择专业二'));
        } else {
          callback();
        }
      };
      var validateVCode = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请先输入图形验证码'));
        } else {
          valilCaptcha({key:this.vcodeuuid,code: this.form.vcode}).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data) {
                callback();
              } else {
                callback(new Error('图形验证码错误'));
              }
            }else{
              callback(new Error('图形验证码错误'));
            }
          })
        }
      };
      var validatePhone = (rule, value, callback) => {
        this.$refs.form.validateField('vcode', error => {
          if (!error) {
            if (!value) {
              callback(new Error('请输入手机号'));
            } else if (!(/^1[3|4|5|7|8][0-9]\d{4,8}$/.test(value))) {
              callback(new Error('请输入正确的手机号'));
            } else {
              vftelStudent({tel: value}).then((response) => {
                let {data} = response
                if (response.status == 200) {
                  if (!data) {
                    callback();
                  } else {
                    callback(new Error('手机号重复'));
                  }
                }else{
                  callback(new Error('手机号重复'));
                }
              })
            }
          }else{
            callback(new Error('请输入正确的手机号'));
          }
        })
      };
      var validateVPhoneCode = (rule, value, callback) => {
        if (!this.form.phone) {
          callback(new Error('请先获取手机验证码'));
        } else if (!value) {
          callback(new Error('请输入手机验证码'));
        } else {
          validateMobileCode({mobile: this.form.phone, code: value}).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                callback();
              } else {
                callback(new Error('手机验证码错误'));
              }
            }else{
              callback(new Error('手机验证码错误'));
            }
          })
        }
      };
      return {
        captchaUrl: '',
        form: {
          cardType: '1',
          cardNumber: '',
          username: '',
          password: '',
          vpassword: '',
          realname: '',
          sex: '',
          province: '',
          city: '',
          county: '',
          rural: '',
          isCustomComp: false,
          company: '',
          customCompForm: {
            province: '',
            city: '',
            county: '',
            rural: '',
            compName: ''
          },
          department: '',
          departmentId: '',
          personType: '',
          specialtyId1: '',
          specialtyId2: '',
          title: '',
          vcode: '',
          vcodeuuid: '',
          phone: '',
          vPhoneCode: '',
        },
        rules: {
          cardType: [
            {required: true, message: '请选择证件类型', trigger: 'change'}
          ],
          cardNumber: [
            {required: true, validator: validateCardNumber, trigger: 'blur'}
          ],
          username: [
            {required: true, validator: validateUsername, trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 6, max: 22, message: '长度在 6 到 22 个字符', trigger: 'blur'}
          ],
          vpassword: [
            {required: true, validator: validateVpassword, trigger: 'blur'}
          ],
          realname: [
            {required: true, validator: validateRealname, trigger: 'blur'}
          ],
          sex: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          company: [
            {required: true, validator: validateCompany, trigger: 'blur,change'}
          ],
          department: [
            {required: true, message: '请输入科室', trigger: 'change'}
          ],
          personType: [
            {required: true, message: '请选择人员类别', trigger: 'change'}
          ],
          specialty: [
            {required: true, validator: validateSpecialty, trigger: 'change'}
          ],
          title: [
            {required: true, message: '请选择职称', trigger: 'change'}
          ],
          vcode: [
            {validator: validateVCode, trigger: 'blur'}
          ],
          phone: [
            {validator: validatePhone, trigger: 'blur'}
          ],
          vPhoneCode: [
            {validator: validateVPhoneCode, trigger: 'blur'}
          ],
        },
        cardTypeOptions: [],//身份证类别
        personTypeOptions: [],//人员类别
        specialtyId1Options: [],//专业1
        specialtyId2Options: [],//专业2
        titleOptions: [],//职称
        compOptions: [],//单位下拉搜索
        compLoading: false,//单位下拉搜索的loading状态
        compPrompt: '无数据',//单位下拉无数据时的提示
        searchCount: 0,//单位搜索次数
        customCompVisible: false,//自填单位的显示
        provinceOptions: [],//省下拉
        cityOptions: [],//市下拉
        countyOptions: [],//县下拉
        ruralOptions: [],//乡下拉
        departmentList: [],//单位下的科室
        time: 0,
        sendSmsButtonDisabled: false,
        agreeContract: true, //是否同意条款
        registerLoading: false,
        registerText: '同意条款并注册',
        registerSuccessTime: 3
      }
    },
    mounted () {
      this.refreshCaptcha()
      getUserDictByColumType({columnType: 1}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.cardTypeOptions = data
        }
      })
      getUserDictByColumType({columnType: 2}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.personTypeOptions = data
        }
      })
      getUserDictByColumType({columnType: 4}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.titleOptions = data
        }
      })
    },
    computed: {
      sendSmsButtonText() {
        const _this=this;
        if (this.time > 0) {
          if (!this.sendSmsButtonDisabled) {
            _this.sendSmsButtonDisabled = true
          }
          return this.time + 's 后重新获取'
        } else {
          _this.sendSmsButtonDisabled = false
          return '获取验证码'
        }
      }
    },
    methods: {
      /*...mapActions([
        'userLogin'
      ]),*/
      remoteSearchComp(compName) {
        if (compName) {
          this.compLoading = true
          listByCompName({compName: compName.replace(/'/g,"")}).then((response) => {
            let {data} = response
            if (response.status == 200 && data.status == 200) {
              this.compOptions = data.data.list;
              this.compLoading = false
              this.compPrompt = '无数据'
            } else {
              this.compOptions = []
              this.compPrompt = data.msg
              this.compLoading = false
            }
          })
          this.searchCount += 1
        } else {
          this.compOptions = [];
          this.compPrompt = '请输入关键字'
        }
      },
      formatRegion(province, city, county, rural) {
        let result = province
        if (city) {
          result += "-" + city;
          if (county) {
            result += "-" + county;
            if (rural) {
              result += "-" + rural;
            }

          }
        }
        return result;
      },
      showCustomComp(){
        this.form.isCustomComp = true;
        getCustomAreaList({
          isAccess: false,
          isSelect: true,
          isPleaseSelect: false,
          province: '',
          city: '',
          county: '',
          orgId: '10'
        }).then((response) => {
          let {data} = response
          if (response.status == 200) {
            this.provinceOptions = data;
          }
        })
      },
      changeArea(val){
        if (val) {
          getCustomAreaList({
            isAccess: false,
            isSelect: true,
            isPleaseSelect: false,
            province: '',
            city: '',
            county: '',
            orgId: val
          }).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (val.length == 4) {
                this.cityOptions = data;
                this.form.customCompForm.city = ''
                this.form.customCompForm.county = ''
                this.form.customCompForm.rural = ''
              } else if (val.length == 6) {
                this.countyOptions = data;
                this.form.customCompForm.county = ''
                this.form.customCompForm.rural = ''
              } else {
                this.ruralOptions = data;
                this.form.customCompForm.rural = ''
              }
            }
          })
        }
      },
      swithSelectComp(){
        this.form.customCompForm.province = ''
        this.form.customCompForm.city = ''
        this.form.customCompForm.county = ''
        this.form.customCompForm.rural = ''
        this.form.customCompForm.compName = ''
        this.form.isCustomComp = false
      },
      searchDepartment(queryString, cb) {
        if (!this.form.isCustomComp && this.form.company) {
          getdepartmentByOrgId({
            orgId: this.form.company
          }).then((response) => {
            let {data} = response
            if (response.status == 200) {
              this.departmentList = data
              var restaurants = this.departmentList;
              var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
              // 调用 callback 返回建议列表的数据
              cb(results);
            }
          })
        }else{
          cb([]);
        }
      },
      departmentSelect(item){
        this.form.department = item.value
      },
      changePersonType(val) {
        this.form.specialtyId1 = ''
        this.form.specialtyId2 = ''
        getSpecialty1Indexs({personType: val}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            this.specialtyId1Options = data
          }
        })
      },
      changeSpecialtyId1(val) {
        this.form.specialtyId2 = ''
        getSpecialty2Indexs({specialtyId1: val}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            this.specialtyId2Options = data
          }
        })
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.indexOf(queryString.toLowerCase()) >= 0);
        };
      },
      refreshCaptcha(){
        this.vcodeuuid=util.guid();
        this.captchaUrl = process.env.VUE_APP_API_URL + 'api/public/captcha/captcha.jpg?key=' + this.vcodeuuid
      },
      sendSmsMethod(){
        this.$refs.form.validateField('phone', error => {
          if (!error) {
            let timestamp = new Date().getTime();
            let sign = sha256(this.form.phone + 3 + timestamp).toString()
            let param = {
              mobile: this.form.phone,
              bType: 3,
              sign: sign,
              timestamp: timestamp,
            }
            sendSms(param).then((response) => {
              let {data} = response
              if (response.status == 200) {
                if (data.status == 200) {
                  this.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  this.time = 60
                  this.smsTimer()
                } else {
                  this.$message({
                    message: data.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error('网络错误！');
              }
            })
          }
        })
      },
      smsTimer() {
        if (this.time > 0) {
          this.time--;
          setTimeout(this.smsTimer, 1000);
        }
      },
      registerSuccessTimer() {
        if (this.registerSuccessTime > 0) {
          this.registerSuccessTime--;
          setTimeout(this.registerSuccessTimer, 1000);
          this.registerText="注册成功，"+this.registerSuccessTime+"秒后返回首页！"
        }else{
          this.$router.push('/')
        }
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid&&!this.registerLoading) {
            this.registerLoading=true
            let param = {
              userName: this.form.username,
              passWord: md5(this.form.password).toString(),
              realName: this.form.realname,
              sex: this.form.sex,
              credentialsType: this.form.cardType,
              sertId: this.form.cardNumber,
              mobile: this.form.phone,
              isMobileVerify: 1,
              personType: this.form.personType,
              specialtyId1: this.form.specialtyId1,
              specialtyId2: this.form.specialtyId2,
              title: this.form.title,
              inputType: 1,
              isCustomComp: this.form.isCustomComp,
              department: this.form.department,
              code: this.form.vPhoneCode
            }
            if (this.form.isCustomComp) {
              param.province = this.form.customCompForm.province
              param.city = this.form.customCompForm.city
              param.county = this.form.customCompForm.county
              param.rural = this.form.customCompForm.rural
              param.companyName = this.form.customCompForm.compName
            } else {
              param.orgId = this.form.company
            }
            studyRegister(param).then((response) => {
              let {data} = response
              if (response.status == 200) {
                if (data.status == 200) {
                  login({
                    username:this.form.username,
                    password:md5(this.form.password).toString()
                  }).then((data) => {
                    if(data.data.code!=1){
                      this.registerSuccessTimer()
                    }else{
                      this.$message(data.msg);
                    }
                  }).catch(() => {
                    this.$message.error('登录异常！');
                  })
                } else {
                  this.$message({
                    message: data.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error('网络错误！');
              }
            })
          } else {
            setTimeout(function(){
              let jump=document.getElementsByClassName('el-form-item__error');
              document.documentElement.scrollTop=document.body.scrollTop=jump[0].parentNode.offsetTop;
            },50);
            return false;
          }
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .elevator {
    position: fixed;
    padding: 0 16px;
    top: 249px;
    /*margin-top: -140px;*/
    right: 0;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 4px 12px 0 rgba(7, 17, 27, .1)
  }

  .elevator a {
    display: block;
    width: 26px;
    padding: 16px 0;
    font-size: 22px;
    line-height: 20px;
    color: #b5b9bc;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #edf1f2
  }

  .elevator a:hover {
    color: #14191e
  }

  .elevator a i {
    font-size: 24px;
    color: #b5b9bc
  }

  .elevator a i:hover {
    color: #14191e
  }

  .elevator a span {
    display: none;
    font-size: 12px;
    color: #f01414;
    line-height: 12px
  }

  .elevator .no-goto {
    border-bottom: none
  }

  .elevator .elevator-app:hover i, .elevator .elevator-faq:hover i, .elevator .elevator-msg:hover i, .elevator .elevator-top:hover i, .elevator .elevator-weixin:hover i {
    display: none
  }

  .elevator .elevator-app:hover span, .elevator .elevator-faq:hover span, .elevator .elevator-msg:hover span, .elevator .elevator-top:hover span, .elevator .elevator-weixin:hover span {
    display: inline-block
  }

  .elevator .elevator-app-box {
    position: absolute;
    width: 172px;
    height: 212px;
    bottom: -2px;
    right: 56px;
    -webkit-transition: opacity .25s, transform .3s;
    -moz-transition: opacity .25s, transform .3s;
    transition: opacity .25s, transform .3s;
    opacity: 0;
    filter: alpha(opacity=0);
    max-width: 0;
    -webkit-transform: scale(.01);
    -ms-transform: scale(.01);
    transform: scale(.01);
    -webkit-transform-origin: 100% 95%;
    -ms-transform-origin: 100% 95%;
    transform-origin: 100% 95%;
  }

  .elevator .elevator-app:hover .elevator-app-box {
    display: block;
    visibility: visible;
    opacity: 1;
    filter: alpha(opacity=100);
    max-width: none;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1)
  }

  .elevator .elevator-weixin-box {
    position: absolute;
    width: 172px;
    height: 212px;
    bottom: -4px;
    right: 56px;
    -webkit-transition: opacity .25s, transform .3s;
    -moz-transition: opacity .25s, transform .3s;
    transition: opacity .25s, transform .3s;
    opacity: 0;
    filter: alpha(opacity=0);
    max-width: 0;
    -webkit-transform: scale(.01);
    -ms-transform: scale(.01);
    transform: scale(.01);
    -webkit-transform-origin: 100% 95%;
    -ms-transform-origin: 100% 95%;
    transform-origin: 100% 95%;
  }

  .elevator .elevator-weixin:hover .elevator-weixin-box {
    display: block;
    visibility: visible;
    opacity: 1;
    filter: alpha(opacity=100);
    max-width: none;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1)
  }
</style>
